import React, { Fragment, useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import { getOptionLabel } from "common/enums";

import Collapse from "./Collapse";

const ResponsiblePersonAuthorityView = ({
  responsiblePersonAuthorities,
  isExpandable = true,
  t,
}) => {
  const fields = useMemo(
    () => [
      {
        name: "Authority Role",
        key: "buildingAuthorityRoleId",
        renderField: (value) =>
          getOptionLabel("buildingAuthorityRoleEnum", value) ?? "-",
      },
      {
        name: "Name",
        key: "name",
        isRequired: true,
      },
      {
        name: "Designation",
        key: "designation",
        isRequired: true,
      },
      {
        name: "Mobile Number",
        key: "mobileNumber",
        isRequired: true,
      },
      {
        name: "Email",
        key: "email",
        isRequired: true,
      },
    ],
    []
  );

  return (
    <>
      <Collapse title="Responsible Person Details" isExpandable={isExpandable}>
        {responsiblePersonAuthorities.map((authority, index) => (
          <Fragment key={authority.id}>
            <Row className="d-flex  mb-2">
              <label className="fw-semibold">
                {t("Responsible Person") + " : " + (index + 1)}
              </label>
              {fields.map(({ name, key, isRequired, renderField }) => {
                const value = get(authority, key, "");
                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(authority, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Fragment>
        ))}
      </Collapse>
    </>
  );
};

ResponsiblePersonAuthorityView.propTypes = {
  responsiblePersonAuthorities: PropTypes.object,
  isExpandable: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(ResponsiblePersonAuthorityView);
